<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="网点名称">
              <a-input
                placeholder="请输入网点名称"
                v-model="queryParam.organizationName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="网点电话">
              <a-input
                placeholder="请输入网点电话"
                v-model="queryParam.organizationType"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" @click="handleAdd" icon="plus"> 新增</a-button>

      <a-button @click="showDialog = true" type="primary" icon="upload"
        >导入</a-button
      >
      <!-- <a-button type="primary" icon="download" @click="handleExportExcel('产品报价')">导出</a-button> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel"
            ><a-icon type="primary" />批量删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <!-- 导入 -->
      <a-modal
        title="上传文件"
        :visible="showDialog"
        @cancel="showDialog = false"
      >
        <a-upload-dragger
          name="file"
          :multiple="true"
          :file-list="fileList"
          accept=".xls,.xlsx"
          :before-upload="beforeUpload"
          :remove="handleRemove"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">点击或拖拽上传文件</p>
        </a-upload-dragger>
        <p
          @click="falling('销售网点')"
          style="float: right; margin-top: 0px; cursor: pointer; color: #1890ff"
        >
          点击下载模板
        </p>
        <template slot="footer">
          <a-button key="back" @click="showDialog = false"> 取消 </a-button>
          <a-button
            :disabled="fileList.length === 0"
            :loading="uploading"
            key="submit"
            type="primary"
            icon="download"
            @click="upload"
          >
            导入
          </a-button>
        </template>
      </a-modal>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true, y: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record.id)">删除</a>
        </span>
      </a-table>
    </div>
    <productNetworksModal
      ref="modalForm"
      @ok="modalFormOk"
    ></productNetworksModal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import productNetworksModal from './productNetworksModal.vue';
import { mixinDevice } from '@/utils/mixin';
import JDate from '@/components/jeecg/JDate';
import { filterObj } from '@/utils/util';
import { uploadAction, postAction, getAction, downFile } from '@/api/manage';
import { getListData, deleteBatch, deleteById } from '@/api/organization.js';
export default {
  name: 'ProductsQuotationList',
  mixins: [mixinDevice],
  components: {
    JDate,
    productNetworksModal
  },
  data() {
    return {
      fileList: [],
      showDialog: false,
      showLead: false,
      uploading: false,
      loading: false,
      // 表头
      columns: [
        {
          title: '网点名称',
          align: 'center',
          sorter: true,
          dataIndex: 'name'
        },
        {
          title: '官网网址',
          align: 'center',
          width: '25%',

          dataIndex: 'web'
        },
        {
          title: '网点电话',
          align: 'center',
          width: '30%',

          dataIndex: 'mobile'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: '20%',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/organization/list',
        delete:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productsOrganization/delete',
        importExcelUrl:
          process.env.VUE_APP_CMS_PRODUCT + '/product/organization/importExcel',
        exportXlsUrl:
          process.env.VUE_APP_CMS_PRODUCT + '/product/organization/exportXls',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productsOrganization/deleteBatch', //批量删除
        exportsUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/organization/downExcelTemplate' //导入模板
      },
      dictOptions: {},
      superFieldList: [],
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      queryParam: {
        name: '',
        mobile: ''
      },
      superQueryParams: '',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      }
    };
  },
  created() {
    this.getList();
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  methods: {
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageSize: that.ipagination.pageSize,
        pageNo: that.ipagination.current,
        name: that.queryParam.organizationName,
        mobile: that.queryParam.organizationType
      };
      that.loading = true;
      getListData(params).then(res => {
        that.loading = false;
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.ipagination.total = res.result.total;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //添加
    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    // 编辑
    handleEdit(record) {
      console.log(record);
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    //点击下载模板
    falling(fileName) {
      downFile(this.url.exportsUrl, { selections: '' }).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
          this.searchQuery();
        }
      });
    },
    // 批量删除
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        let ids = this.selectedRowKeys.join(',');
        let that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            let formData = new FormData();
            formData.append('ids', ids);
            deleteBatch(formData).then(res => {
              that.loading = false;
              if (res.success) {
                that.$message.success(res.message);
                that.getList();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            });
          }
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          let formData = new FormData();
          formData.append('id', id);
          deleteById(formData).then(res => {
            that.loading = false;
            if (res.success) {
              that.getList(1);
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      this.ipagination = pagination;
      this.getList();
    },
    channel() {
      this.showDialog = true;
    },
    //excel转换
    productToLead() {
      this.showLead = true;
    },
    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    upload() {
      let formData = new FormData();
      this.uploading = true;
      formData.set('file', this.fileList[0]);

      uploadAction(this.url.importExcelUrl, formData)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.uploading = false;
          this.fileList = [];
          this.showDialog = false;
          this.searchQuery();
        });
    },

    //单条审核

    // 导出excel
    handleExportExcel(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件';
      }
      if (this.selectionRows.length <= 0) {
        return this.$message.warning('请选择一条数据');
      }
      let param = { ...this.queryParam };
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['selections'] = this.selectedRowKeys.join(',');
      }
      console.log('导出参数', param);
      downFile(this.url.exportXlsUrl, param).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
          this.searchQuery();
        }
      });
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
